import { z } from 'zod';

import { CONTRACT_SORT_FIELDS } from '~/data/contract';

/**
 * Page-owned search state for the contracts list route.
 *
 * Sorting defaults mirror the API defaults (`modified_on`, `desc`).
 * Buyer/seller/contract/status/search filters are not route state: the
 * universal filters store owns them, and `savedFilterId` is the only bridge
 * between the selected backend saved filter and the URL.
 */
export const zodContractsSearchSchema = z.object({
  importJobsPage: z.coerce.number().int().nonnegative().default(0).catch(0),
  page: z.coerce.number().int().nonnegative().default(0).catch(0),
  savedFilterId: z.uuid().optional().catch(undefined),
  sortBy: z
    .enum(CONTRACT_SORT_FIELDS)
    .default('modified_on')
    .catch('modified_on'),
  sortOrder: z.enum(['asc', 'desc']).default('desc').catch('desc'),
  viewImportJobId: z.uuid().optional().catch(undefined),
});

export const contractsSearchDefaults = zodContractsSearchSchema.parse({});

/**
 * Search and page of a contract's line items table, shared by the contract
 * details page and the create/edit form. Kept in the URL so returning from a
 * line item page restores the table.
 */
export const zodContractItemsTableSearchSchema = z.object({
  itemsPage: z.coerce.number().int().nonnegative().default(0).catch(0),
  itemsSearch: z.string().default('').catch(''),
});
